import { html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import {
  Pagination,
  SearchRequest,
  SearchResultOfBaseSearchModel,
} from "../../openApiClients/generated/EngineeringUK.Sites";
import { SearchBaseComponent } from "./SearchBaseComponent";

@customElement("euk-search-pagination")
export class SearchPaginationComponent extends SearchBaseComponent {
  @property({ type: Object })
  request?: SearchRequest;

  pagination?: Pagination | null;
  @property({ type: Boolean })
  showPages: boolean = false;

  @property({ type: String })
  totalPagesDescriptor: string = "of";

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.addListener<SearchResultOfBaseSearchModel>(
      this.resultUpdateEvent,
      async (e) => {
        const result = e.detail;
        this.pagination = result.pagination;
        this.requestUpdate();
      }
    );
    this.addListener<SearchRequest>(this.requestUpdateEvent, async (e) => {
      const result = e.detail;
      this.request = result;
      this.requestUpdate();
    });
  }

  private previousPage() {
    if (!this.request) {
      return;
    }
    this.request.page -= 1;
    super.triggerEvent(this.request ?? {}, this.requestUpdateEvent);
  }

  private nextPage() {
    if (!this.request) {
      return;
    }
    this.request.page += 1;
    super.triggerEvent(this.request ?? {}, this.requestUpdateEvent);
  }

  render() {
    if (!this.request || !this.pagination || this.pagination.totalPages <= 1) {
      return html``;
    }
    const page = this.request?.page ?? 1;
    const totalPages = this.pagination?.totalPages ?? 1;
    return html`
      ${super.render()}
      <ul class="pager">
        <li class="pager__previous">
          <a
            @click="${this.previousPage}"
            href="#listing"
            class="btn btn--primary ${page <= 1 ? "btn--disabled" : null}"
            rel="prev"
            ><slot name="Previous">Previous</slot></a
          >
        </li>
        ${this.showPagesNumbersOrSummaryOfPages(
          page,
          totalPages,
          this.totalPagesDescriptor
        )}
        <li class="pager__next">
          <a
            @click="${this.nextPage}"
            href="#listing"
            class="btn btn--primary ${page == totalPages
              ? "btn--disabled"
              : null}"
            rel="next"
            ><slot name="Next">Next</slot></a
          >
        </li>
      </ul>
    `;
  }

  showPagesNumbersOrSummaryOfPages(
    page: number,
    totalPages: number,
    totalPagesDescriptor: string
  ) {
    return !this.showPages
      ? html`<li class="pager__summary">
          <span
            ><b>${page}</b> ${totalPagesDescriptor} <b>${totalPages}</b></span
          >
        </li>`
      : html`
          ${Array.from({ length: totalPages }, (_, i) => i + 1).map((i) => {
            if (i === page) {
              return html`<span>${i}</span>`;
            }
            return html` <button
              @click="${() => {
                if (!this.request) {
                  return;
                }
                this.request.page = i;
                this.triggerEvent(this.request ?? {}, this.requestUpdateEvent);
              }}"
            >
              ${i}
            </button>`;
          })}
        `;
  }

  static styles = css``;
}
